import img_0 from '../images/img_0.png';
import img_1 from '../images/img_1.png';

export default {
  v: '5.7.4',
  fr: 25,
  ip: 0,
  op: 50,
  w: 2050,
  h: 1059,
  nm: 'KROS_LOTTIE',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 910, h: 446, u: '', p: img_0, e: 0 },
    { id: 'image_1', w: 910, h: 446, u: '', p: img_1, e: 0 },
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: 'kros1_1.png',
          cl: 'png',
          refId: 'image_0',
          sr: 1,
          ks: {
            r: {
              a: 1,
              k: [
                { i: { x: [0.668], y: [0.521] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
                { i: { x: [0.89], y: [1] }, o: { x: [0.539], y: [0.08] }, t: 12, s: [4.426] },
                { i: { x: [0.757], y: [1] }, o: { x: [0.116], y: [0] }, t: 36, s: [90.737] },
                { i: { x: [0.667], y: [1] }, o: { x: [0.238], y: [0] }, t: 70, s: [-22.952] },
                { i: { x: [0.833], y: [0.833] }, o: { x: [0.403], y: [1.37] }, t: 78, s: [-1.907] },
                { t: 102, s: [0] },
              ],
            },
            p: {
              s: true,
              x: {
                a: 1,
                k: [
                  {
                    i: { x: [0.654], y: [0.622] },
                    o: { x: [0.318], y: [0.241] },
                    t: 0,
                    s: [672.43],
                  },
                  { i: { x: [0.666], y: [1] }, o: { x: [0.325], y: [0.505] }, t: 12, s: [511.081] },
                  { i: { x: [0.667], y: [0.66] }, o: { x: [0.354], y: [0] }, t: 32, s: [321.754] },
                  { i: { x: [0.655], y: [1] }, o: { x: [0.324], y: [0.601] }, t: 60, s: [922.007] },
                  { i: { x: [0.561], y: [0.43] }, o: { x: [0.182], y: [0] }, t: 70, s: [1039.77] },
                  {
                    i: { x: [0.842], y: [0.857] },
                    o: { x: [0.373], y: [0.341] },
                    t: 80,
                    s: [950.768],
                  },
                  { t: 102, s: [672.624] },
                ],
              },
              y: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [837.85] },
                  { i: { x: [0.805], y: [1] }, o: { x: [0.648], y: [0] }, t: 12, s: [839.1] },
                  { i: { x: [0.601], y: [1] }, o: { x: [0.255], y: [0] }, t: 41, s: [651.1] },
                  { i: { x: [0.721], y: [1] }, o: { x: [0.333], y: [0] }, t: 60, s: [802.1] },
                  { i: { x: [0.351], y: [1] }, o: { x: [0.358], y: [0] }, t: 70, s: [783.35] },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 80,
                    s: [839.1],
                  },
                  { t: 102, s: [838.1] },
                ],
              },
            },
            a: { a: 0, k: [471.3, 273.216, 0] },
            s: { a: 0, k: [42.377, 42.377, 100] },
          },
          ao: 0,
          ef: [
            {
              ty: 34,
              nm: 'Puppet',
              np: 6,
              mn: 'ADBE FreePin3',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 7,
                  nm: 'Puppet Engine',
                  mn: 'ADBE FreePin3 Puppet Engine',
                  ix: 1,
                  v: { a: 0, k: 2 },
                },
                {
                  ty: 0,
                  nm: 'Mesh Rotation Refinement',
                  mn: 'ADBE FreePin3 Auto Rotate Pins',
                  ix: 2,
                  v: { a: 0, k: 20 },
                },
                {
                  ty: 7,
                  nm: 'On Transparent',
                  mn: 'ADBE FreePin3 On Transparent',
                  ix: 3,
                  v: { a: 0, k: 0 },
                },
                {
                  ty: 25,
                  nm: 'arap',
                  np: 3,
                  mn: 'ADBE FreePin3 ARAP Group',
                  ix: 4,
                  en: 1,
                  ef: [
                    { ty: 6, nm: 'Auto-traced Shapes', mn: 'ADBE FreePin3 Outlines', ix: 1, v: 0 },
                    {
                      ty: 1,
                      nm: 'Mesh',
                      np: 2,
                      mn: 'ADBE FreePin3 Mesh Group',
                      ix: 2,
                      en: 1,
                      ef: [
                        {
                          nm: 'Mesh 1',
                          np: 8,
                          mn: 'ADBE FreePin3 Mesh Atom',
                          ix: 1,
                          en: 1,
                          ef: [
                            { ty: 6, nm: 'Mesh', mn: 'ADBE FreePin3 Mesh', ix: 1, v: 0 },
                            {
                              ty: 0,
                              nm: 'Triangles',
                              mn: 'ADBE FreePin3 Mesh Tri Count',
                              ix: 2,
                              v: { a: 0, k: 50 },
                            },
                            {
                              ty: 0,
                              nm: 'Density',
                              mn: 'ADBE FreePin3 Mesh Tri Density',
                              ix: 3,
                              v: { a: 0, k: 9 },
                            },
                            {
                              ty: 0,
                              nm: 'Expansion',
                              mn: 'ADBE FreePin3 Mesh Expansion',
                              ix: 4,
                              v: { a: 0, k: 16 },
                            },
                            {
                              nm: 'Deform',
                              np: 5,
                              mn: 'ADBE FreePin3 PosPins',
                              ix: 5,
                              en: 1,
                              ef: [
                                {
                                  nm: 'Puppet Pin 4',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 1,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 30 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [835.608, 303.95],
                                            to: [-0.756, -2.27],
                                            ti: [6.228, 11.955],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [831.075, 290.331],
                                            to: [-6.228, -11.955],
                                            ti: [8.75, 14.127],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [798.239, 232.223],
                                            to: [-8.75, -14.127],
                                            ti: [9.515, 2.003],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [778.577, 205.57],
                                            to: [-9.515, -2.003],
                                            ti: [7.143, -12.626],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [741.152, 220.205],
                                            to: [-7.143, 12.626],
                                            ti: [-15.743, -13.958],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [735.717, 281.328],
                                            to: [15.743, 13.958],
                                            ti: [-16.648, -3.77],
                                          },
                                          { t: null, s: [835.608, 303.95] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                                {
                                  nm: 'Puppet Pin 3',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 2,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 31 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [676.268, 339.952],
                                            to: [-0.336, -2.137],
                                            ti: [1.925, 8.905],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [674.25, 327.131],
                                            to: [-1.925, -8.905],
                                            ti: [3.078, 8.386],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [664.717, 286.52],
                                            to: [-3.078, -8.386],
                                            ti: [1.36, -8.065],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [655.783, 276.815],
                                            to: [-1.36, 8.065],
                                            ti: [-2.664, -15.496],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [656.555, 334.912],
                                            to: [2.664, 15.496],
                                            ti: [-3.286, -0.84],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [671.765, 369.789],
                                            to: [3.286, 0.84],
                                            ti: [-0.751, 4.973],
                                          },
                                          { t: null, s: [676.268, 339.952] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                                {
                                  nm: 'Puppet Pin 2',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 3,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 32 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [527.053, 353.869],
                                            to: [-0.705, -0.685],
                                            ti: [2.05, 1.426],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [522.823, 349.757],
                                            to: [-2.05, -1.426],
                                            ti: [1.589, -0.344],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [514.752, 345.31],
                                            to: [-1.589, 0.344],
                                            ti: [1.04, -6.691],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [513.289, 351.822],
                                            to: [-1.04, 6.691],
                                            ti: [0.431, -4.063],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [508.512, 385.456],
                                            to: [-0.431, 4.063],
                                            ti: [-3.09, 5.265],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [510.701, 376.199],
                                            to: [3.09, -5.265],
                                            ti: [-2.725, 3.722],
                                          },
                                          { t: null, s: [527.053, 353.869] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                                {
                                  nm: 'Puppet Pin 1',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 4,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 33 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [102.275, 339.413],
                                            to: [-0.225, -0.164],
                                            ti: [0.854, -0.927],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [100.926, 338.431],
                                            to: [-0.854, 0.927],
                                            ti: [0.192, -1.046],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [97.149, 344.974],
                                            to: [-0.192, 1.046],
                                            ti: [-0.358, 0.311],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [99.774, 344.709],
                                            to: [0.358, -0.311],
                                            ti: [0.275, 0.288],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [99.298, 343.11],
                                            to: [-0.275, -0.288],
                                            ti: [-0.496, 0.616],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [98.125, 342.982],
                                            to: [0.496, -0.616],
                                            ti: [-0.692, 0.595],
                                          },
                                          { t: null, s: [102.275, 339.413] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              nm: 'Overlap',
                              np: 1,
                              mn: 'ADBE FreePin3 HghtPins',
                              ix: 6,
                              en: 1,
                              ef: [],
                            },
                            {
                              nm: 'Stiffness',
                              np: 1,
                              mn: 'ADBE FreePin3 StarchPins',
                              ix: 7,
                              en: 1,
                              ef: [],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          ip: 0,
          op: 750,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: 'comp_1',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: 'kros1_2.png',
          cl: 'png',
          refId: 'image_1',
          sr: 1,
          ks: {
            r: {
              a: 1,
              k: [
                { i: { x: [0.668], y: [0.521] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
                { i: { x: [0.89], y: [1] }, o: { x: [0.539], y: [0.08] }, t: 12, s: [4.426] },
                { i: { x: [0.757], y: [1] }, o: { x: [0.116], y: [0] }, t: 36, s: [90.737] },
                { i: { x: [0.667], y: [1] }, o: { x: [0.238], y: [0] }, t: 70, s: [-22.952] },
                { i: { x: [0.833], y: [0.833] }, o: { x: [0.403], y: [1.37] }, t: 78, s: [-1.907] },
                { t: 102, s: [0] },
              ],
            },
            p: {
              s: true,
              x: {
                a: 1,
                k: [
                  {
                    i: { x: [0.654], y: [0.622] },
                    o: { x: [0.318], y: [0.241] },
                    t: 0,
                    s: [672.43],
                  },
                  { i: { x: [0.666], y: [1] }, o: { x: [0.325], y: [0.505] }, t: 12, s: [511.081] },
                  { i: { x: [0.667], y: [0.66] }, o: { x: [0.354], y: [0] }, t: 32, s: [321.754] },
                  { i: { x: [0.655], y: [1] }, o: { x: [0.324], y: [0.601] }, t: 60, s: [922.007] },
                  { i: { x: [0.561], y: [0.43] }, o: { x: [0.182], y: [0] }, t: 70, s: [1039.77] },
                  {
                    i: { x: [0.842], y: [0.857] },
                    o: { x: [0.373], y: [0.341] },
                    t: 80,
                    s: [950.768],
                  },
                  { t: 102, s: [672.624] },
                ],
              },
              y: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [837.85] },
                  { i: { x: [0.805], y: [1] }, o: { x: [0.648], y: [0] }, t: 12, s: [839.1] },
                  { i: { x: [0.601], y: [1] }, o: { x: [0.255], y: [0] }, t: 41, s: [651.1] },
                  { i: { x: [0.721], y: [1] }, o: { x: [0.333], y: [0] }, t: 60, s: [802.1] },
                  { i: { x: [0.351], y: [1] }, o: { x: [0.358], y: [0] }, t: 70, s: [783.35] },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 80,
                    s: [839.1],
                  },
                  { t: 102, s: [838.1] },
                ],
              },
            },
            a: { a: 0, k: [471.3, 273.216, 0] },
            s: { a: 0, k: [42.377, 42.377, 100] },
          },
          ao: 0,
          ef: [
            {
              ty: 34,
              nm: 'Puppet',
              np: 6,
              mn: 'ADBE FreePin3',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 7,
                  nm: 'Puppet Engine',
                  mn: 'ADBE FreePin3 Puppet Engine',
                  ix: 1,
                  v: { a: 0, k: 2 },
                },
                {
                  ty: 0,
                  nm: 'Mesh Rotation Refinement',
                  mn: 'ADBE FreePin3 Auto Rotate Pins',
                  ix: 2,
                  v: { a: 0, k: 20 },
                },
                {
                  ty: 7,
                  nm: 'On Transparent',
                  mn: 'ADBE FreePin3 On Transparent',
                  ix: 3,
                  v: { a: 0, k: 0 },
                },
                {
                  ty: 25,
                  nm: 'arap',
                  np: 3,
                  mn: 'ADBE FreePin3 ARAP Group',
                  ix: 4,
                  en: 1,
                  ef: [
                    { ty: 6, nm: 'Auto-traced Shapes', mn: 'ADBE FreePin3 Outlines', ix: 1, v: 0 },
                    {
                      ty: 1,
                      nm: 'Mesh',
                      np: 2,
                      mn: 'ADBE FreePin3 Mesh Group',
                      ix: 2,
                      en: 1,
                      ef: [
                        {
                          nm: 'Mesh 1',
                          np: 8,
                          mn: 'ADBE FreePin3 Mesh Atom',
                          ix: 1,
                          en: 1,
                          ef: [
                            { ty: 6, nm: 'Mesh', mn: 'ADBE FreePin3 Mesh', ix: 1, v: 0 },
                            {
                              ty: 0,
                              nm: 'Triangles',
                              mn: 'ADBE FreePin3 Mesh Tri Count',
                              ix: 2,
                              v: { a: 0, k: 50 },
                            },
                            {
                              ty: 0,
                              nm: 'Density',
                              mn: 'ADBE FreePin3 Mesh Tri Density',
                              ix: 3,
                              v: { a: 0, k: 9 },
                            },
                            {
                              ty: 0,
                              nm: 'Expansion',
                              mn: 'ADBE FreePin3 Mesh Expansion',
                              ix: 4,
                              v: { a: 0, k: 16 },
                            },
                            {
                              nm: 'Deform',
                              np: 5,
                              mn: 'ADBE FreePin3 PosPins',
                              ix: 5,
                              en: 1,
                              ef: [
                                {
                                  nm: 'Puppet Pin 4',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 1,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 26 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [833.392, 305.897],
                                            to: [-0.418, -2.024],
                                            ti: [5.276, 9.843],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [830.883, 293.751],
                                            to: [-5.276, -9.843],
                                            ti: [8.649, 14.728],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [801.733, 246.839],
                                            to: [-8.649, -14.728],
                                            ti: [8.757, 4.341],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [778.986, 205.383],
                                            to: [-8.757, -4.341],
                                            ti: [6.548, -11.693],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [749.191, 220.791],
                                            to: [-6.548, 11.693],
                                            ti: [-14.034, -14.184],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [739.7, 275.541],
                                            to: [14.034, 14.184],
                                            ti: [-15.615, -5.059],
                                          },
                                          { t: null, s: [833.392, 305.897] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                                {
                                  nm: 'Puppet Pin 3',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 2,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 27 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [675.682, 343.844],
                                            to: [-0.26, -1.651],
                                            ti: [2.667, 7.69],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [674.122, 333.937],
                                            to: [-2.667, -7.69],
                                            ti: [6.981, 7.566],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [659.679, 297.702],
                                            to: [-6.981, -7.566],
                                            ti: [3.875, -9.582],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [632.238, 288.54],
                                            to: [-3.875, 9.582],
                                            ti: [-5.575, -15.395],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [636.43, 355.194],
                                            to: [5.575, 15.395],
                                            ti: [-6.542, 1.892],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [665.687, 380.912],
                                            to: [6.542, -1.892],
                                            ti: [-1.666, 6.178],
                                          },
                                          { t: null, s: [675.682, 343.844] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                                {
                                  nm: 'Puppet Pin 2',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 3,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 28 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [525.018, 356.245],
                                            to: [-1.472, 0.132],
                                            ti: [3.773, -0.063],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [516.185, 357.039],
                                            to: [-3.773, 0.063],
                                            ti: [4.347, -1.11],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [502.382, 356.625],
                                            to: [-4.347, 1.11],
                                            ti: [5.26, -6.707],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [490.103, 363.699],
                                            to: [-5.26, 6.707],
                                            ti: [3.065, -4.159],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [470.823, 396.866],
                                            to: [-3.065, 4.159],
                                            ti: [-9.033, 6.77],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [471.712, 388.655],
                                            to: [9.033, -6.77],
                                            ti: [-8.884, 5.402],
                                          },
                                          { t: null, s: [525.018, 356.245] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                                {
                                  nm: 'Puppet Pin 1',
                                  np: 7,
                                  mn: 'ADBE FreePin3 PosPin Atom',
                                  ix: 4,
                                  en: 1,
                                  ef: [
                                    {
                                      ty: 3,
                                      nm: 'Vertex Offset',
                                      mn: 'ADBE FreePin3 PosPin Vtx Offset',
                                      ix: 1,
                                      v: { a: 0, k: [0, 0] },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Vertex Index',
                                      mn: 'ADBE FreePin3 PosPin Vtx Index',
                                      ix: 2,
                                      v: { a: 0, k: 29 },
                                    },
                                    {
                                      ty: 7,
                                      nm: 'Pin Type',
                                      mn: 'ADBE FreePin3 PosPin Type',
                                      ix: 3,
                                      v: { a: 0, k: 1 },
                                    },
                                    {
                                      ty: 3,
                                      nm: 'Position',
                                      mn: 'ADBE FreePin3 PosPin Position',
                                      ix: 4,
                                      v: {
                                        a: 1,
                                        k: [
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [102.184, 338.237],
                                            to: [-0.072, 0.808],
                                            ti: [-0.177, -0.622],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [101.753, 343.082],
                                            to: [0.177, 0.622],
                                            ti: [-0.053, -0.055],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [103.249, 341.967],
                                            to: [0.053, 0.055],
                                            ti: [0.01, 0.105],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [102.069, 343.412],
                                            to: [-0.01, -0.105],
                                            ti: [-0.383, 0.325],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [103.192, 341.337],
                                            to: [0.383, -0.325],
                                            ti: [0.168, 0.517],
                                          },
                                          {
                                            i: { x: 0, y: 0 },
                                            o: { x: 0, y: 0 },
                                            t: 0,
                                            s: [104.365, 341.464],
                                            to: [-0.168, -0.517],
                                            ti: [0.363, 0.538],
                                          },
                                          { t: null, s: [102.184, 338.237] },
                                        ],
                                      },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Scale',
                                      mn: 'ADBE FreePin3 PosPin Scale',
                                      ix: 5,
                                      v: { a: 0, k: 100 },
                                    },
                                    {
                                      ty: 0,
                                      nm: 'Rotation',
                                      mn: 'ADBE FreePin3 PosPin Rotation',
                                      ix: 6,
                                      v: { a: 0, k: 0 },
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              nm: 'Overlap',
                              np: 1,
                              mn: 'ADBE FreePin3 HghtPins',
                              ix: 6,
                              en: 1,
                              ef: [],
                            },
                            {
                              nm: 'Stiffness',
                              np: 1,
                              mn: 'ADBE FreePin3 StarchPins',
                              ix: 7,
                              en: 1,
                              ef: [],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          ip: 0,
          op: 750,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: 'NULL CONTROL',
      sr: 1,
      ks: {
        o: { a: 0, k: 0 },
        p: { a: 0, k: [1246.144, 213.5, 0] },
        a: { a: 0, k: [60, 60, 0] },
        s: { a: 0, k: [186.667, 186.667, 100] },
      },
      ao: 0,
      ip: -25,
      op: 717,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: 'kros1_front',
      parent: 1,
      refId: 'comp_0',
      sr: 1,
      ks: { p: { a: 0, k: [60, 60, 0] }, a: { a: 0, k: [800, 529.5, 0] } },
      ao: 0,
      tm: {
        a: 1,
        k: [
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: -25, s: [0] },
          { t: 25, s: [4.08] },
        ],
        x: 'var $bm_rt;\n$bm_rt = loopOut();',
      },
      w: 1600,
      h: 1059,
      ip: -25,
      op: 692,
      st: -25,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 0,
      nm: 'kros1_back',
      parent: 1,
      refId: 'comp_1',
      sr: 1,
      ks: { p: { a: 0, k: [60, 60, 0] }, a: { a: 0, k: [800, 529.5, 0] } },
      ao: 0,
      tm: {
        a: 1,
        k: [
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
          { t: 50, s: [4.08] },
        ],
        x: 'var $bm_rt;\n$bm_rt = loopOut();',
      },
      w: 1600,
      h: 1059,
      ip: 0,
      op: 717,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
